$(document).ready(function () {
  const mainCartSection = document.querySelector('.shopify-section--main-cart');
  if (!mainCartSection) {
    return;
  }
  const sectionId = mainCartSection.id;

  // Initialize popup functionality only for non-section-3 items
  initializeGiftWrappingPopup();
  // Initialize tab toggle functionality
  initializeTabToggle();

  var __selectedGiftWrappingPapperId = $('.kg-gift-wrapping-service-checkbox').first().attr('data-selected-gift-wrapper');
  if (__selectedGiftWrappingPapperId != 'false') {
    var __giftWrappingPapperQuantityInput = $('.kg-line-item-quantity-input-number[data-line-key="' + __selectedGiftWrappingPapperId + '"]');
    if (__giftWrappingPapperQuantityInput) {
      const __GiftWrappingQuantityInputQty = parseInt(__giftWrappingPapperQuantityInput.val());
      const __giftWrappingServiceParams = getWrappingServiceParams();
      if (__giftWrappingServiceParams && __GiftWrappingQuantityInputQty != __giftWrappingServiceParams[0]) {
        saveGiftWrappingPapperProduct();
      }
    }
  }
  
  var giftWrappingButton1 = $(document).find("#cart-gift-wrapping");
  var isGiftChecked = giftWrappingButton1.attr("data-is-checked");
  if (isGiftChecked != undefined && isGiftChecked != '') {
    if (isGiftChecked == 'false') {
      var toggleBlockId = giftWrappingButton1.attr("data-toggle-element-id");
      if (toggleBlockId != undefined && toggleBlockId != '') {
        $(document).find("#" + toggleBlockId).show();
      }
    }
  }

  // Updated click handler for gift wrapping items - section 3 adds directly, others open popup
  $(document).on('click', '.kg-gift-wrapping-items', function (e) {
    e.preventDefault(); // Prevent any default behavior
    
    // Check if this is from section 3
    const isSection3 = $(this).closest('#is-a-gift-3').length > 0;
    
    if (isSection3) {
      // For section 3, add directly to cart without popup
      var variantId = $(this).attr('data-gift-id');
      if (variantId != undefined && variantId != '') {
        processCartFunction('add', variantId, 1);
      }
    } else {
      // For other sections, open popup as before
      openGiftWrappingPopup($(this));
    }
  });

  $(document).on('click', '.kg-is-a-gift-checkbox-input-button', function () {
    var variantId = $(this).attr('data-gift-id');
    if (variantId != undefined && variantId != '') {
      if ($(this).is(':checked')) {
        processCartFunction('add', variantId, 1);
      } else {
        processCartFunction('change', variantId, 0);
      }
    }
  });

  $(document).on('change', '.kg-gift-wrapping-service-checkbox', function () {
    var currentTriggerProductId = $(this).attr('data-cart-product-id');
    var selectedGiftWrappingPapperId = $(this).attr('data-selected-gift-wrapper');
    if ($(this).is(':checked')) {
      checkWrappingService(currentTriggerProductId);
    } else {
      unCheckWrappingService(currentTriggerProductId);
    }
    if (selectedGiftWrappingPapperId != 'false') {
      saveGiftWrappingPapperProduct();
    } else {
      var giftWrappingServiceParams = getWrappingServiceParams();
      if (giftWrappingServiceParams) {
        $('html, body').animate({
          scrollTop: $('#is-a-gift-4').offset().top - 150
        }, 800); // Smooth scroll in 800ms
      }
    }
  });

  $(document).on('click', '.kg-gift-wrapping-papper-items', function () {
    var selectedGiftWrappingPapperId = $('.kg-gift-wrapping-service-checkbox').first().attr('data-selected-gift-wrapper');
    var giftWrappingServiceParams = getWrappingServiceParams();
    if (selectedGiftWrappingPapperId == 'false' && giftWrappingServiceParams) {
      var kgGiftWrappingPapperId = $(this).attr('data-gift-id');
      saveGiftWrappingPapperProduct(kgGiftWrappingPapperId);
    } else {
      $('html, body').animate({
        scrollTop: $('.kg-cart-page-form').offset().top - 300
      }, 400);
    }
  });

  $(document).on('click', '.kg-line-item-quantity-input', function (event) {
    event.preventDefault(); // Prevent default link behavior
    var kgRedirectUrlParams = new URL($(this).attr('data-href'), window.location.origin);
    var kgMainProductId = kgRedirectUrlParams.searchParams.get('id');
    var kgMainProductQuantity = kgRedirectUrlParams.searchParams.get('quantity');
    var kgWrappingServiceId = $(this).attr('data-wrapping-service-index');
    if (kgWrappingServiceId) {
      $(".kg-gift-wrapping-service-checkbox[data-cart-product-id='" + kgWrappingServiceId + "']").attr('data-cart-product-qty', kgMainProductQuantity);
      processCartFunction('change', kgMainProductId, kgMainProductQuantity, '', function () {
        saveGiftWrappingPapperProduct();
      });
    } else {
      processCartFunction('change', kgMainProductId, kgMainProductQuantity);
    }
  });
  
  $(document).on('click', '.kg-cart-line-item-remove-link', function (event) {
    event.preventDefault(); // Prevent default link behavior
    var kgPhotoGiftCheckbox = $("#kg-is-a-gift-checkbox");
    var kgWrappingServiceId = $(this).attr('data-wrapping-service-index');
    var kgIsPersonalisedProduct = $(this).attr('data-personalised-product');
    var kgIsPersonalisedProductCount = parseInt($(this).attr('data-personalised-product-count')) - 1;
    var kgRedirectUrlParams = new URL($(this).attr('data-href'), window.location.origin);
    var kgMainProductId = kgRedirectUrlParams.searchParams.get('id');
    if (kgWrappingServiceId) {
      unCheckWrappingService(kgWrappingServiceId);
    }

    if (kgIsPersonalisedProduct && kgIsPersonalisedProductCount == 0 && kgPhotoGiftCheckbox.is(':checked')) {
      var kgkgPhotoGiftVariantId = kgPhotoGiftCheckbox.attr("data-gift-id");
      if (kgWrappingServiceId) {
        processCartFunction('change', kgkgPhotoGiftVariantId, 0, '', function () {
          processCartFunction('change', kgMainProductId, 0, '', function () {
            saveGiftWrappingPapperProduct();
          });
        });
      } else {
        processCartFunction('change', kgkgPhotoGiftVariantId, 0, '', function () {
          processCartFunction('change', kgMainProductId, 0);
        });
      }
    } else {
      if (kgWrappingServiceId) {
        processCartFunction('change', kgMainProductId, 0, '', function () {
          saveGiftWrappingPapperProduct();
        });
      } else {
        processCartFunction('change', kgMainProductId, 0);
      }
    }
  });

  // Gift Wrapping Popup Functions - Only for non-section-3 items
  function initializeGiftWrappingPopup() {
    // Close popup when clicking close button or overlay
    $(document).on('click', '.popup-close, .popup-overlay', function(e) {
      e.preventDefault(); // Prevent default behavior
      e.stopPropagation(); // Stop event bubbling
      closeGiftWrappingPopup();
    });

    // Prevent popup content from closing when clicking inside popup
    $(document).on('click', '.popup-content', function(e) {
      e.stopPropagation();
    });

    // Add to cart when clicking the add button in popup (for non-section-3 items)
    $(document).on('click', '#popup-add-button', function(e) {
      e.preventDefault(); // Prevent default behavior
      addGiftWrappingFromPopup($(this));
    });

    // Close popup with ESC key
    $(document).on('keydown', function(e) {
      if (e.keyCode === 27) { // ESC key
        e.preventDefault();
        closeGiftWrappingPopup();
      }
    });
  }

  // Tab toggle functionality
  function initializeTabToggle() {
    $(document).on('click', '.tab-header', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      const $tabHeader = $(this);
      const $tabContent = $tabHeader.closest('.product-info-tabs').find('.tab-content');
      const $tabArrow = $tabHeader.find('.tab-arrow');
      
      // Toggle the collapsed state
      if ($tabContent.hasClass('collapsed')) {
        // Open the tab
        $tabContent.removeClass('collapsed');
        $tabHeader.removeClass('collapsed');
        $tabArrow.css('transform', 'rotate(0deg)');
      } else {
        // Close the tab
        $tabContent.addClass('collapsed');
        $tabHeader.addClass('collapsed');
        $tabArrow.css('transform', 'rotate(-90deg)');
      }
    });
  }

  function openGiftWrappingPopup(giftElement) {
  // Don't open popup for section 3 items
  const isSection3 = giftElement.closest('#is-a-gift-3').length > 0;
  if (isSection3) {
    return;
  }
  
  const variantId = giftElement.attr('data-gift-id');
  const price = giftElement.attr('data-gift-price');
  const title = giftElement.attr('data-gift-title');
  const vendor = giftElement.attr('data-gift-vendor');
  const image = giftElement.attr('data-gift-image');
  const description = giftElement.attr('data-gift-description');
  
  // Format price using our custom function
  const formattedPrice = formatMoney(price, '{{ amount }}');

  // Populate popup content
  $('#popup-gift-image').attr('src', image).attr('alt', title);
  $('#popup-thumbnail-gift-image').attr('src', image).attr('alt', title);
  
  // Conditionally show vendor if available
  if (vendor && vendor.trim() !== '') {
    $('#popup-gift-vendor').text(vendor);
    $('#popup-vendor-container').show();
  } else {
    $('#popup-vendor-container').hide();
  }
  
  // Conditionally show title if available
  if (title && title.trim() !== '') {
    $('#popup-gift-title').text(title).show();
  } else {
    $('#popup-gift-title').hide();
  }
  
  $('#popup-gift-price').text(formattedPrice);
  
  // Conditionally show product information tab
  if (description && description.trim() !== '') {
    $('#popup-gift-description').text(description);
    $('#product-info-tabs').show();
    
    // Start with tab closed by default
    $('#product-info-tabs .tab-content').addClass('collapsed');
    $('#product-info-tabs .tab-header').addClass('collapsed');
    $('#product-info-tabs .tab-arrow').css('transform', 'rotate(-90deg)');
  } else {
    $('#product-info-tabs').hide();
  }
  
  // Clear previous message
  $('#personalized-message').val('');
  
  // Store the variant ID in the add button for later use
  $('#popup-add-button').attr('data-variant-id', variantId);

 
// Show the popup
$('#gift-wrapping-popup').show();
$('body').css('overflow', 'hidden');

// Auto-scroll to bottom on mobile devices
setTimeout(function() {
  if (window.innerWidth <= 768) {
    console.log("Custom scroll calculation");
    
    const messageInput = document.querySelector('#personalized-message');
    const targetElement = messageInput || document.querySelector('#popup-add-button');
    
    if (targetElement) {
      // // Focus if it's the message input
      // if (messageInput) {
      //   messageInput.focus({ preventScroll: false });
      // }
      messageInput.focus();
      setTimeout(() => {
        // Calculate custom scroll position
        const elementRect = targetElement.getBoundingClientRect();
        const absoluteElementTop = elementRect.top + window.pageYOffset;
        const middle = absoluteElementTop - (window.innerHeight / 3); // Scroll to show element at 1/3 from top
        
        window.scrollTo({
          top: middle,
          behavior: 'smooth'
        });
        
        messageInput.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }, 300); // adjust based on modal animation

      
    }
  }
}, 100);
}

  function closeGiftWrappingPopup() {
    // Close popup
    $('#gift-wrapping-popup').hide();
    $('body').css('overflow', 'auto');
    
    return false;
  }

  function addGiftWrappingFromPopup(addButton) {
    const variantId = addButton.attr('data-variant-id');
    const personalizedMessage = $('#personalized-message').val().trim();
    
    if (variantId) {
      // Create properties object with personalized message - only if message exists
      const properties = {};
      
      if (personalizedMessage) {
        properties['Schrijf hier je persoonlijke boodschap voor je wenskaart.'] = personalizedMessage;
      }
      
      processCartFunction('add', variantId, 1, properties);
      closeGiftWrappingPopup();
    }
  }

  function getWrappingServiceParams() {
    var kgGiftWrappingPaperQty = 0;
    var kgGiftWrappingPaperProductIds = [];
    var kgGiftWrappingPaperProductTitles = [];

    $('.kg-gift-wrapping-service-checkbox:checked').each(function () {
      var productId = $(this).attr('data-cart-product-id');
      var productTitle = $(this).attr('data-cart-product-title'); // Get product title
      var productQuantity = $(this).attr('data-cart-product-qty'); // Get product qty

      if (!kgGiftWrappingPaperProductIds.includes(productId)) {
        kgGiftWrappingPaperQty += parseInt(productQuantity);
        kgGiftWrappingPaperProductIds.push(productId);
        kgGiftWrappingPaperProductTitles.push(productTitle);
      }
    });

    if (kgGiftWrappingPaperQty > 0) {
      let kgPropertiesObject = {
        "_pihws": kgGiftWrappingPaperProductIds.join(',') // Store product IDs as a comma-separated string
      };

      // Add product titles as separate properties
      kgGiftWrappingPaperProductTitles.forEach((kgProductTitle, index) => {
        kgPropertiesObject[`Gift wrapping product ${index + 1}`] = kgProductTitle;
      });

      return [kgGiftWrappingPaperQty, kgPropertiesObject];
    }
    return false;
  }

  function saveGiftWrappingPapperProduct(kgGiftWrappingPapperId = '') {
    var selectedGiftWrappingPapperId = $('.kg-gift-wrapping-service-checkbox').first().attr('data-selected-gift-wrapper');
    var giftWrappingServiceParams = getWrappingServiceParams();
    var kgCartFunction = "add";
    var kgCartQuantity = 1;
    var kgCartPropertyValue = '';

    if (selectedGiftWrappingPapperId != 'false') {
      kgCartFunction = "change";
    }

    if (giftWrappingServiceParams) {
      kgCartQuantity = giftWrappingServiceParams[0];
      kgCartPropertyValue = giftWrappingServiceParams[1];
    }

    if (selectedGiftWrappingPapperId != 'false' && !giftWrappingServiceParams) {
      kgCartQuantity = 0;
      kgCartPropertyValue = '';
    }

    if (kgGiftWrappingPapperId) {
      selectedGiftWrappingPapperId = kgGiftWrappingPapperId;
    }

    if (mainCartSection && selectedGiftWrappingPapperId != 'false') {
      processCartFunction(kgCartFunction, selectedGiftWrappingPapperId, kgCartQuantity, kgCartPropertyValue);
    }
  }

  function processCartFunction(cartFlag, variantId, variantQuantity, variantProperties = '', callBack = null) {
    if (mainCartSection) {
      startLoading();
      $.ajax({
        url: '/cart/' + cartFlag + '.js',
        type: 'post',
        dataType: 'json',
        data: {
          quantity: variantQuantity,
          id: variantId,
          properties: variantProperties
        },
        success: function () {
          if (callBack) {
            callBack();
          } else {
            refreshCartHtml();
          }
        },
        error: function (errorMsg) {
          endLoading();
          consoleLogContent(errorMsg);
        }
      });
    }
  }

  function refreshCartHtml() {
    fetch(location.href)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const updatedSection = doc.querySelector(`#${sectionId}`);
        if (updatedSection) {
          mainCartSection.innerHTML = updatedSection.innerHTML;
        }
      })
      .catch(error => console.error("Error loading cart section:", error))
      .finally(() => {
        endLoading();
      });
  }

  function checkWrappingService(kgLineItemkey) {
    $(".kg-gift-wrapping-service-checkbox[data-cart-product-id='" + kgLineItemkey + "']").attr('checked', true);
  }
  function unCheckWrappingService(kgLineItemkey) {
    $(".kg-gift-wrapping-service-checkbox[data-cart-product-id='" + kgLineItemkey + "']").attr('checked', false);
  }

  function startLoading() {
    const overlayLoader = document.getElementById("overlay-loader");
    if (overlayLoader) {
      overlayLoader.style.display = "";
    }
  }

  function endLoading() {
    const overlayLoader = document.getElementById("overlay-loader");
    if (overlayLoader) {
      overlayLoader.style.display = "none";
    }
  }
  function consoleLogContent(textContent) {
    console.log(textContent);
  }
});

// Money formatting function
function formatMoney(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || '{{ amount }}';

  function formatWithDelimiters(number, precision, thousands, decimal) {
    thousands = thousands || ',';
    decimal = decimal || '.';

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.');
    var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var price = dollars + (parts[1] ? decimal + parts[1] : '');

    return price;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
}
